module.exports = __webpack_public_path__ + "static/media/times.0b4c1db9.png";